"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchSuggestions = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _contexts = require("../contexts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * Hook for retrieving and managing state of Search Suggestions
 */
const useSearchSuggestions = () => {
  const api = (0, _contexts.useCommerceAPI)();
  const [state, setState] = (0, _react.useState)({
    results: {}
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    /**
     * Retrieves search suggestions from api based on input
     *
     * @param {input} string
     */
    getSearchSuggestions(input) {
      return (0, _asyncToGenerator2.default)(function* () {
        // @ts-ignore
        setState({
          loading: true
        });
        // @ts-ignore
        const searchSuggestions = yield api.shopperSearch.getSearchSuggestions({
          parameters: {
            q: input
          }
        });
        setState({
          results: searchSuggestions
        });
      })();
    },
    /**
     * Clears results
     */
    clearSuggestedSearch() {
      return (0, _asyncToGenerator2.default)(function* () {
        setState({
          results: {}
        });
      })();
    }
  });
};
exports.useSearchSuggestions = useSearchSuggestions;